import { LandlineConsumptionInterface } from '../../models/landline-consumption.interface';

export interface LandlineConsumptionInterfaceState {
  landlineConsumption: LandlineConsumptionInterface;
}

export const initialLandlineConsumptionState: LandlineConsumptionInterfaceState = {
  landlineConsumption: null
};
